import { DEFAULT_SELECTED_SEARCH_TYPE_INDEX } from '../../../constants';
import { CommonSearchTypeOptions, FieldType, OnlineDatabaseField } from '../../../../components/GenericSection/constants';
var ONLINE_DATABASE_PUBINFO_SECTION_FIELDS = [{
  fields: [{
    field: OnlineDatabaseField.LIBRARY,
    labelText: 'Library',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: OnlineDatabaseField.CITY,
    labelText: 'City',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  fields: [{
    field: OnlineDatabaseField.DATABASE,
    labelText: 'Database',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: OnlineDatabaseField.SERVICE,
    labelText: 'Service',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  field: OnlineDatabaseField.DATE_ACCESSED,
  type: FieldType.PUBDATE,
  labelText: 'Date accessed',
  formikFieldNames: ['dayaccessed', 'monthaccessed', 'yearaccessed']
}, {
  field: OnlineDatabaseField.SEARCH_TYPE,
  type: FieldType.RADIO_GROUP_WITH_INPUT,
  radioName: 'pubdatabase.searchtype',
  inputName: 'pubdatabase.searchtext',
  defaultSelectedIndex: DEFAULT_SELECTED_SEARCH_TYPE_INDEX,
  options: [CommonSearchTypeOptions.KEYWORD, CommonSearchTypeOptions.PATH, CommonSearchTypeOptions.URL],
  alignment: 'horizontal',
  labelText: 'Search type'
}];
export default ONLINE_DATABASE_PUBINFO_SECTION_FIELDS;